import {Component, Inject, LOCALE_ID} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
    MatExpansionPanel,
    MatExpansionPanelDescription,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle
} from '@angular/material/expansion';
import {NgIf, NgOptimizedImage} from '@angular/common';
import {SPBanner} from '../model/SPBanner';

@Component({
  selector: 'app-reklama',
  standalone: true,
  imports: [
    MatExpansionPanel,
    MatExpansionPanelDescription,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    NgIf,
    NgOptimizedImage
  ],
  templateUrl: './reklama.component.html',
  styleUrl: './reklama.component.css'
})
export class ReklamaComponent {

  protected show = false;
  protected imgSrc = '';
  protected linkaBannera = '';

  constructor(
    @Inject(LOCALE_ID) private locale: string,
    private http: HttpClient
  ) {}

  ngOnInit(): void
  {
    this.http.get<SPBanner>('/ais/rest/portal/student/reklama')
      .subscribe((data: SPBanner) => {
        if (data !== null) {
          this.imgSrc = data.bannerCesta + data.bannerSubor;
          this.linkaBannera = data.linkaBannera;
          this.show = true;
        }
      });
  }

}
